import { combineLatest, map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { idMapToArray, ScopeService } from './scope.service';
import { KPI } from '../api';

@Injectable({
  providedIn: 'root'
})
export class AssetTypesService {

  constructor(
    private scopeService: ScopeService,
  ) { }

  public get mappedAssetTypes$(): Observable<KPI.MappedAssetType[]> {
    return combineLatest([
      this.scopeService.superCategories$.pipe(idMapToArray()),
      this.scopeService.categories$.pipe(idMapToArray()),
      this.scopeService.subCategories$.pipe(idMapToArray()),
      this.scopeService.assetTypes$.pipe(idMapToArray()),
    ]).pipe(
      map(([superCategories, categories, subCategories, assetTypes]) => {
        // Map the asset types to include the parent objects
        return assetTypes.map(assetType => {
          const sub_category = subCategories.find(subCategory => subCategory.id === assetType.parent);
          const category = categories.find(category => category.id === sub_category.parent);
          const super_category = superCategories.find(superCategory => superCategory.id === category.parent);
          return {
            ...assetType,
            super_category,
            category,
            sub_category,
          };
        });
      }),
    );
  }
}
